import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Dialog,
    DialogTitle,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Avatar
} from '@material-ui/core';

import { PageContext } from '../PageContext';

import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ErrorIcon from '@material-ui/icons/Error';
import HelpIcon from '@material-ui/icons/Help';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export const HelpDialog = ({
    open,
    disabled,
    onClose,
    onFileUploaded,
    ...props }) => {
    const classes = useStyles();

    return (
        <Dialog
            aria-labelledby="table-content-import"
            open={open}
            onClose={onClose} >
            <DialogTitle id="table-content-import">
                Fields Caption
            </DialogTitle>
            <List>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar>
                            <VpnKeyIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText>
                        Indicates the unique identifier of the table
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar>
                            <ErrorIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText>
                        Value must be always not null
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar>
                            <HelpIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText>
                        Value can be null
                    </ListItemText>
                </ListItem>
            </List>
        </Dialog>
    );
}